import { Controller, useFormContext } from 'react-hook-form'

import { ctrTINTypes } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TINType = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.tinType"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => (
        <FF2
          required
          label="78. TIN type"
          field={field}
          input={(props) => (
            <Select {...props} data={ctrTINTypes} data-qa="78. TIN type" options-data-qa="78. TIN type option" />
          )}
        />
      )}
    />
  )
}
